import { GeographicCoordinatesDirection } from "../models/dms-coordinates-input.models";

export type CoordinateType = "latitude" | "longitude";

/**
 * Returns the direction key for a given coordinate value and type.
 * @param value The coordinate value (positive or negative)
 * @param type The coordinate type (latitude or longitude)
 * @returns Direction key: 'N'/'S' for latitude, 'E'/'W' for longitude
 */
export function getCoordinateDirection(value: number, type: CoordinateType): GeographicCoordinatesDirection {
    const isLatitude = type === "latitude";

    if (isLatitude) {
        return value >= 0 ? GeographicCoordinatesDirection.North : GeographicCoordinatesDirection.South;
    }

    return value >= 0 ? GeographicCoordinatesDirection.East : GeographicCoordinatesDirection.West;
}
